import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["modal", "trigger"]

  connect() {
    this.triggerTarget.addEventListener("click", () => { $(this.modalTarget).modal("show") })
  }
}